import axios from 'axios';
import { getAccessToken } from '@/assets/js/auth';

export const addPaymentMethod = async (data, customerId) => {
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`,
      'Content-Type': 'application/json'
    }
  };

  return axios.post(`/api/payment-methods?customer_id=${customerId}`, data, settings);
}

export const getPaymentMethod = async (customerId) => {
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  return axios.get(`/api/payment-methods?customer_id=${customerId}`, settings);
}

export const updatePaymentMethods = async (data, customerId) => {
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`,
      'Content-Type': 'application/json'
    }
  };

  return axios.patch(`/api/payment-methods?customer_id=${customerId}`, data, settings);
}

export const getAvailablePaymentMethods = async (customerId) => {
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  return axios.get(`/api/payment-methods/available?customer_id=${customerId}`, settings);
}

export const paymentMethodSession = async (data, customerId) => {
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  return axios.post(`/api/payment-methods/session?customer_id=${customerId}`, data, settings);
}

export const creditCardValidation = async (data, customerId) => {
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  return axios.post(`/api/payment-methods/validate?customer_id=${customerId}`, data, settings);
}

export const retrieveCustomerStripeId = async (customerId) => {
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  return axios.get(`/api/payment-methods/foreign_id?customer_id=${customerId}`, settings);
}
